import { put, select, call } from 'redux-saga/effects'
import { mapActivityData } from 'utils/activities'
import { convertFromToUser } from 'utils/users'
import fetchPermissionLevel from 'routes/Board/sagas/fetchPermissionLevel'
import {
  setName as setBoardName,
  positionLists,
  addList as addListToView,
  removeList as removeListFromView,
  setIsPublic,
  setIsClosed,
} from 'routes/Board/redux/view'
import {
  add as addList,
  remove as removeList,
  setName as setListName,
  setDescription as setListDescription,
  setSettings as setListSettings
} from 'routes/Board/redux/lists'
import {
  add as addCard,
  addArray as addCardArray,
  addCardFronts,
  remove as removeCard,
  setListId as setCardListId,
  setName as setCardName,
  setDueDate as setCardDueDate,
  setDueDateId as setCardDueDateId,
  setStartDate as setCardStartDate,
  setStartDateId as setCardStartDateId,
  setListChangeDate as setCardListChangeDate,
  setStatusChangeDate as setCardStatusChangeDate,
  setListChangedBy as setCardListChangedBy,
  setStatusChangedBy as setCardStatusChangedBy,
  setStatus as setCardStatus,
  increaseFileCount as increaseFileCountInCard,
  decreaseFileCount as decreaseFileCountInCard,
  increaseChecklistItemCount as increaseChecklistItemCountInCard,
  decreaseChecklistItemCount as decreaseChecklistItemCountInCard,
  increaseCompletedChecklistItemCount as increaseCompletedChecklistItemCountInCard,
  decreaseCompletedChecklistItemCount as decreaseCompletedChecklistItemCountInCard,
  increaseNoteCount as increaseNoteCountInCard,
  decreaseNoteCount as decreaseNoteCountInCard,
  setResponsible as setResponsibleForCard,
  removeResponsible as removeResponsibleFromCard,
  addUser as addUserToCard,
  removeUser as removeUserFromCard,
  addLabel as addLabelToCard,
  removeLabel as removeLabelFromCard,
  removeLabelFromAllCards,
  removeStatusFromAllCards,
  setPositions as setCardPositions,
  setStatusPositions as setCardInStatusPositions,
  setRelatedCardDates,
  setBlockerCount as setBlockerCountInCard,
} from 'routes/Board/redux/cards'
import {
  add as addArchivedCard,
  remove as removeArchivedCard,
  addArray as addArchivedCardArray
} from 'routes/Board/redux/archivedCards'
import {
  set as setSettings
} from 'routes/Board/redux/settings'
import {
  add as addChatMessage,
  addReply as addChatReply,
  setLiked as setMessageLiked,
  increaseRepliesCount as increaseMessageRepliesCount,
  increaseLikeCount as increaseMessageLikeCount,
  decreaseLikeCount as decreaseMessageLikeCount,
  increaseUnreadMessageCount as increaseChatUnreadMessageCount
} from 'routes/Board/redux/chat'
import {
  add as addLabel,
  remove as removeLabel,
  setName as setLabelName,
  setColor as setLabelColor,
  setPosition as setLabelPosition
} from 'routes/Board/redux/labels'
import {
  add as addActivity,
  remove as removeActivity,
  set as setActivity
} from 'routes/Board/redux/activities'
import {
  add as addDocumentSource,
  remove as removeDocumentSource,
  setDefaultDocumentSource,
  setDocumentSource
} from 'routes/Board/redux/documentSources'
import {
  add as addDocumentTemplateSource,
  remove as removeDocumentTemplateSource,
} from 'routes/Board/redux/documentTemplateSources'
import {
  add as addCardStatus,
  remove as removeCardStatus,
  addArray as addCardStatusArray,
  setName as setCardStatusName,
  setDescription as setCardStatusDescription,
  setColor as setCardStatusColor,
  setPositions as setCardStatusPositions
} from 'routes/Board/redux/cardStatuses'
import {
  add as addUserGroupToView,
  remove as removeUserGroupFromView,
  setDefaultOwnerUserGroupId,
  setDefaultMemberUserGroupId,
  setDefaultVisitorUserGroupId,
} from 'routes/Board/redux/userGroups'
import {
  refresh as refreshUsers
} from 'routes/Board/redux/users'
import {
  addItem as addDate,
  removeItem as removeDate,
  setItem as setDate
} from 'routes/Board/redux/dates'
import {
  add as addUserGroup
} from 'store/redux/userGroups'
import {
  add as addIncomingMail,
  remove as removeIncomingMail,
  set as setIncomingMail
} from 'store/redux/incomingMails'
import {
  addCardRelation,
  removeCardRelation
} from 'store/redux/cardRelations'
import {
  add as addView,
  setName as setViewName,
  setIsPublic as setViewIsPublic,
  setSettings as setViewSettings,
  setPendingSettings as setViewPendingSettings,
  remove as removeView,
  setPosition as setViewPosition,
} from 'routes/Board/redux/views'
import {
  add as addBlockerToBoard,
  remove as removeBlockerFromBoard,
} from 'routes/Board/redux/blockers'
import {
  add as addBlocker,
} from 'store/redux/blockers'
import {
  setCardRelation,
} from 'store/redux/cardRelations'
import * as CalendarItemTypes from 'const/CalendarItemTypes'
import sweetalert from 'sweetalert2'

function * handleCardChange ({ Id, StatusId, StatusPosition, StatusChangeDate, StatusChangedBy, ListChangeDate, ListChangedBy, StartDate, DueDate, CardBlockersCount, DefaultParentId }) {
  if (typeof StatusId !== 'undefined') {
    yield put(setCardStatus({
      id: Id,
      statusId: StatusId
    }))
  }

  if (typeof StatusPosition !== 'undefined') {
    yield put(setCardInStatusPositions([{
      id: Id,
      position: StatusPosition,
    }]))
  }

  if (typeof StatusChangeDate !== 'undefined') {
    yield put(setCardStatusChangeDate({
      id: Id,
      statusChangeDate: StatusChangeDate
    }))
  }

  if (typeof StatusChangedBy !== 'undefined') {
    yield put(setCardStatusChangedBy({
      id: Id,
      statusChangedBy: StatusChangedBy
    }))
  }

  if (typeof ListChangeDate !== 'undefined') {
    yield put(setCardListChangeDate({
      id: Id,
      listChangeDate: ListChangeDate
    }))
  }

  if (typeof ListChangedBy !== 'undefined') {
    yield put(setCardListChangedBy({
      id: Id,
      listChangedBy: ListChangedBy
    }))
  }

  if (typeof StartDate !== 'undefined') {
    yield put(setRelatedCardDates({
      id: Id,
      startDate: StartDate
    }))
  }

  if (typeof DueDate !== 'undefined') {
    yield put(setRelatedCardDates({
      id: Id,
      dueDate: DueDate
    }))
  }

  if (typeof CardBlockersCount !== 'undefined') {
    yield put(setBlockerCountInCard({
      id: Id,
      blockerCount: CardBlockersCount
    }))
  }

  if (typeof DefaultParentId !== 'undefined') {
    yield put(setCardRelation({
      id: Id,
      defaultParentId: DefaultParentId
    }))
  }
}

export default function * channelData ({ boardId }, action) {
  const { channel, actionName, elementName, data } = action.payload

  const state = yield select()

  const currentUserId = state.kanbo.currentUser.id

  if (actionName + elementName === 'AddBoardView/Data/BoardView') {
    const { Id, BoardId, Type, Name, IsPublic, Settings, Position } = data

    yield put(addView({
      boardId: BoardId,
      view: {
        id: Id,
        name: Name,
        type: Type,
        isPublic: IsPublic,
        settings: Settings,
        position: Position,
      }
    }))
  } else if (actionName + elementName === 'RenameBoardView/Data/BoardView') {
    const { Id, Name } = data

    yield put(setViewName({
      viewId: Id,
      name: Name,
    }))
  } else if (actionName + elementName === 'ChangeBoardViewVisibility/Data/BoardView') {
    const { Id, IsPublic } = data

    yield put(setViewIsPublic({
      viewId: Id,
      isPublic: IsPublic,
    }))
  } else if (actionName + elementName === 'ChangeBoardViewSettings/Data/BoardView') {
    const { Id, Settings } = data

    yield put(setViewSettings({
      viewId: Id,
      settings: Settings,
    }))

    if (
      state['view-board'].views.viewsById[Id] &&
      state['view-board'].views.viewsById[Id].pendingSettings
    ) {
      try {
        yield call(sweetalert, {
          type: 'info',
          text: state.kanbo.locale.messages['BOARD_VIEW_CHANGED_DISCARD_QUESTION'],
          confirmButtonText: state.kanbo.locale.messages['YES'],
          cancelButtonText: state.kanbo.locale.messages['NO'],
          showCancelButton: true,
        })

        yield put(setViewPendingSettings({
          viewId: Id,
          pendingSettings: undefined,
        }))
      } catch (e) {}
    }
  } else if (actionName + elementName === 'RemoveBoardView/Primitive/Int32') {
    const { Value } = data

    yield put(removeView({
      viewId: Value,
    }))
  } else if (elementName === '/Positions/BoardViews') {
    const { Positions } = data

    if (Positions.length) {
      yield put(Positions.map(({ Id, Position }) => setViewPosition({
        viewId: Id,
        position: Position
      })))
    }
  } else if (channel === 'board-' + boardId) { // ----- BOARD CHANNEL -----
    if (actionName + elementName === 'RenameBoard/Data/Board') {
      const { Name } = data
      yield put(setBoardName({
        boardId,
        name: Name
      }))
    } else if (actionName + elementName === 'OpenBoard/Data/Board/Id') {
      const { Id } = data

      yield put(setIsClosed({
        boardId: Id,
        isClosed: false
      }))
    } else if (actionName + elementName === 'CloseBoard/Data/Board/Id') {
      const { Id } = data

      yield put(setIsClosed({
        boardId: Id,
        isClosed: true
      }))
    } else if (actionName + elementName === 'AddCard/Data/CardFront') {
      const Card = data

      yield put(addCardFronts([Card]))
    } else if (actionName + elementName === 'RenameCard/Data/IdName') {
      const { Id, Name } = data
      yield put(setCardName({
        id: Id,
        name: Name
      }))
    } else if (actionName + elementName === 'SetDueDate/Data/CalendarEvent') {
      const { Id, CardId, Timestamp } = data
      yield put([
        setCardDueDate({
          id: CardId,
          dueDate: Timestamp
        }),
        setCardDueDateId({
          id: CardId,
          dueDateId: Id
        })
      ])
    } else if (actionName + elementName === 'RemoveDueDate/Data/CardDate') {
      const { CardId } = data
      yield put([
        setCardDueDate({
          id: CardId,
          dueDate: null
        }),
        setCardDueDateId({
          id: CardId,
          dueDateId: null
        })
      ])
    } else if (actionName + elementName === 'SetStartDate/Data/CalendarEvent') {
      const { Id, CardId, Timestamp } = data
      yield put([
        setCardStartDate({
          id: CardId,
          startDate: Timestamp
        }),
        setCardStartDateId({
          id: CardId,
          startDateId: Id
        })
      ])
    } else if (actionName + elementName === 'RemoveStartDate/Data/CardDate') {
      const { CardId } = data
      yield put([
        setCardStartDate({
          id: CardId,
          startDate: null
        }),
        setCardStartDateId({
          id: CardId,
          startDateId: null
        })
      ])
    } else if (elementName === '/Positions/Cards') {
      const { Positions } = data

      yield put(setCardPositions(Positions.map(Card => ({
        id: Card.Id,
        position: Card.Position
      }))))
    } else if (elementName === '/Positions/CardsInStatus') {
      const { Positions } = data

      yield put(setCardInStatusPositions(Positions.map(Card => ({
        id: Card.Id,
        position: Card.Position
      }))))
    } else if (elementName === '/Positions/CardTemplates') {
      const { Positions } = data

      yield put(setCardPositions(Positions.map(Card => ({
        id: Card.Id,
        position: Card.Position
      }))))
    } else if (actionName + elementName === 'ChangeParent/Data/Move<Card>') {
      const { ContainerToId, ElementId } = data
      yield put(setCardListId({
        id: ElementId,
        listId: ContainerToId
      }))
    } else if (actionName + elementName === 'MoveCard/Data/CardFront') {
      yield put(addCardFronts([data]))
    } else if (actionName + elementName === 'CopyCard/Data/CardFront') {
      yield put(addCardFronts([data]))
    } else if (actionName + elementName === 'ArchiveCard/Data/CardFront') {
      const Card = data

      yield put(addCardFronts([Card]))

      yield put(addArchivedCard({
        boardId,
        cardId: Card.Id,
      }))
    } else if (actionName + elementName === 'UnarchiveCard/Data/CardFront') {
      const Card = data

      yield put(removeArchivedCard({
        boardId,
        id: Card.Id
      }))

      yield put(addCardFronts([Card]))
    } else if (
      actionName + elementName === 'ArchiveCardsInList/Data/ListCards' ||
      actionName + elementName === 'ArchiveCardsInStatus/Data/ListCards' ||
      actionName + elementName === 'ArchiveCardsWithLabel/Data/ListCards'
    ) {
      const { Cards } = data

      const archivedCards = []
      const cardIds = Cards.map(Card => {
        archivedCards.push({
          ...state['view-board'].cards[Card.Id],
          id: Card.Id,
          boardId,
          listId: null,
          isArchived: true,
          archiveDate: Card.ArchiveDate,
        })

        return Card.Id
      })

      yield put(addCardArray(archivedCards))

      yield put(addArchivedCardArray({
        boardId,
        array: cardIds,
      }))
    } else if (actionName + elementName === 'ArchiveCardsWithUser/Data/BoardCards') {
      const { Cards } = data

      const archivedCards = []
      const cardIds = Cards.map(Card => {
        archivedCards.push({
          ...state['view-board'].cards[Card.Id],
          id: Card.Id,
          boardId,
          listId: null,
          isArchived: true,
          archiveDate: Card.ArchiveDate,
        })

        return Card.Id
      })

      yield put(addCardArray(archivedCards))

      yield put(addArchivedCardArray({
        boardId,
        array: cardIds,
      }))
    } else if (actionName + elementName === 'RemoveCard/Data/Card') {
      const { Id } = data

      yield put(removeCard({
        id: Id
      }))
    } else if (actionName + elementName === 'AddUserToCard/Data/CardUser') {
      const { Id, CardId, IsResponsible } = data
      if (IsResponsible) {
        yield put(setResponsibleForCard({
          id: CardId,
          responsible: Id
        }))
      } else {
        yield put(addUserToCard({
          id: CardId,
          userId: Id
        }))
      }
    } else if (actionName + elementName === 'RemoveUserFromCard/Data/CardUser') {
      const { Id, CardId, IsResponsible } = data
      if (IsResponsible) {
        yield put(removeResponsibleFromCard({
          id: CardId
        }))
      } else {
        yield put(removeUserFromCard({
          id: CardId,
          userId: Id
        }))
      }
    } else if (actionName + elementName === 'MakeUserResponsible/Data/CardUser') {
      const { Id, CardId } = data

      yield put(setResponsibleForCard({
        id: CardId,
        responsible: Id
      }))
    } else if (actionName + elementName === 'AddLabel/Data/Label') {
      const Label = data
      yield put(addLabel({
        boardId,
        label: {
          id: Label.Id,
          name: Label.Name,
          color: Label.Color,
          position: Label.Position
        }
      }))
    } else if (actionName + elementName === 'RemoveLabel/Primitive/Int32') {
      const { Value } = data
      yield put(removeLabelFromAllCards({
        labelId: Value
      }))
      yield put(removeLabel({
        boardId,
        labelId: Value
      }))
    } else if (actionName + elementName === 'AddLabelToCard/Data/Label') {
      const { Id, CardId } = data
      yield put(addLabelToCard({
        id: CardId,
        labelId: Id
      }))
    } else if (actionName + elementName === 'RemoveLabelFromCard/Data/LabelInCard') {
      const { LabelId, CardId } = data
      yield put(removeLabelFromCard({
        id: CardId,
        labelId: LabelId
      }))
    } else if (actionName + elementName === 'RenameLabel/Data/Label') {
      const { Id, Name } = data
      yield put(setLabelName({
        labelId: Id,
        name: Name
      }))
    } else if (actionName + elementName === 'ChangeLabelColor/Data/LabelColor') {
      const { Id, Color } = data
      yield put(setLabelColor({
        labelId: Id,
        color: Color
      }))
    } else if (elementName === '/Positions/Labels') {
      const { Positions } = data

      if (Positions.length) {
        yield put(Positions.map(({ Id, Position }) => setLabelPosition({
          labelId: Id,
          position: Position
        })))
      }
    } else if (actionName + elementName === 'AddDocumentsListItem/Data/DocumentsListItem') {
      const Document = data
      yield put(increaseFileCountInCard({
        id: Document.CardId
      }))
    } else if (actionName + elementName === 'RemoveDocumentsListItem/Data/DocumentsListItem') {
      const Document = data

      yield put(decreaseFileCountInCard({
        id: Document.CardId
      }))
    } else if (actionName + elementName === 'EventDocumentRemove/Data/ListItemsPerCard') {
      const { ListItemPerCard } = data

      const length = ListItemPerCard.length
      for (let i = 0; i < length; i++) {
        const ListItem = ListItemPerCard[i]

        yield put(decreaseFileCountInCard({
          id: ListItem.Id,
          count: ListItem.Count
        }))
      }
    } else if (actionName + elementName === 'AddChecklistItem/Data/ChecklistItem') {
      const { CardId } = data

      yield put(increaseChecklistItemCountInCard({
        id: CardId
      }))
    } else if (
      actionName + elementName === 'RemoveChecklistItem/Data/ChecklistItem' ||
      actionName + elementName === 'ConvertChecklistItemToCard/Data/ConvertedChecklistItem/ChecklistItem'
    ) {
      const { CardId, Completed } = data

      yield put(decreaseChecklistItemCountInCard({
        id: CardId
      }))
      if (Completed) {
        yield put(decreaseCompletedChecklistItemCountInCard({
          id: CardId
        }))
      }
    } else if (actionName + elementName === 'ConvertChecklistItemToCard/Data/CardFront') {
      yield put(addCardFronts([data]))
    } else if (actionName + elementName === 'CompleteChecklistItem/Data/ChecklistItem') {
      const { CardId } = data

      yield put(increaseCompletedChecklistItemCountInCard({
        id: CardId
      }))
    } else if (actionName + elementName === 'UncompleteChecklistItem/Data/ChecklistItem') {
      const { CardId } = data

      yield put(decreaseCompletedChecklistItemCountInCard({
        id: CardId
      }))
    } else if (actionName + elementName === 'AddNote/Data/Note') {
      const { CardId } = data

      yield put(increaseNoteCountInCard({
        id: CardId
      }))
    } else if (actionName + elementName === 'RemoveElement/Data/ElementWithCount') {
      const { CardId, Type, DocumentsListItemCount, ChecklistItemCount, CompletedChecklistItemCount } = data

      if (DocumentsListItemCount > 0) {
        yield put(decreaseFileCountInCard({
          id: CardId,
          count: DocumentsListItemCount
        }))
      }
      if (ChecklistItemCount > 0) {
        yield put(decreaseChecklistItemCountInCard({
          id: CardId,
          count: ChecklistItemCount
        }))
      }
      if (CompletedChecklistItemCount > 0) {
        yield put(decreaseCompletedChecklistItemCountInCard({
          id: CardId,
          count: CompletedChecklistItemCount
        }))
      }

      if (Type === 'Note') {
        yield put(decreaseNoteCountInCard({
          id: CardId
        }))
      }
    } else if (actionName + elementName === 'SetCardStatus/Card/Status') {
      const { CardId, CardStatusId } = data
      yield put(setCardStatus({
        id: CardId,
        statusId: CardStatusId
      }))
    } else if (actionName + elementName === 'AddList/Data/List') {
      const { Id, Name, Description, Role, Settings, Position } = data
      yield put(addList({
        id: Id,
        name: Name,
        description: JSON.parse(Description),
        isLoaded: true,
        role: Role,
        settings: {
          color: Settings.Color,
          wipLimit: Settings.WIPLimit,
        }
      }))
      yield put(addListToView({
        boardId,
        listId: Id,
        index: Position
      }))
    } else if (actionName + elementName === 'RemoveList/Data/List') {
      const { Id } = data
      yield put(removeListFromView({
        boardId,
        listId: Id,
      }))
      yield put(removeList({
        id: Id
      }))
    } else if (actionName + elementName === 'RenameList/Data/List') {
      const { Id, Name } = data
      yield put(setListName({
        id: Id,
        name: Name
      }))
    } else if (actionName + elementName === 'SetListDescription/Data/List') {
      const { Id, Description } = data
      yield put(setListDescription({
        id: Id,
        description: JSON.parse(Description)
      }))
    } else if (actionName + elementName === 'ChangeListSettings/Data/Settings') {
      const { Id, Settings } = data
      yield put(setListSettings({
        id: Id,
        settings: {
          color: Settings.Color,
          wipLimit: Settings.WIPLimit,
        }
      }))
    } else if (elementName === '/Positions/Lists') {
      const { Positions } = data
      let positionsById = {}
      Positions.forEach(list => {
        positionsById[list.Id] = list.Position
      })
      yield put(positionLists({
        boardId,
        positionsById,
      }))
    } else if (actionName + elementName === 'ChangeBoardBackground/Data/Board/Background') {
      const { Background } = data

      yield put(setSettings({
        boardId,
        settings: {
          background: Background
        }
      }))
    } else if (actionName + elementName === 'AddBoardChatMessage/Data/ChatMessage') {
      const { Id, From, JsonMessage, Timestamp } = data

      yield put(addChatMessage({
        boardId,
        message: {
          id: Id,
          from: From,
          message: JSON.parse(JsonMessage),
          timestamp: Timestamp,
          index: 0
        }
      }))

      const fromUser = convertFromToUser(From)
      if (!(fromUser.type === 'USER' && fromUser.id === currentUserId)) {
        yield put(increaseChatUnreadMessageCount({ boardId }))
      }
    } else if (actionName + elementName === 'AddBoardChatReply/Data/ChatMessage') {
      const { Id, From, ParentId, JsonMessage, Timestamp } = data

      yield put(addChatReply({
        boardId,
        messageId: ParentId,
        reply: {
          id: Id,
          from: From,
          message: JSON.parse(JsonMessage),
          timestamp: Timestamp
        }
      }))

      yield put(increaseMessageRepliesCount({
        boardId,
        messageId: ParentId
      }))

      const fromUser = convertFromToUser(From)
      if (!(fromUser.type === 'USER' && fromUser.id === currentUserId)) {
        yield put(increaseChatUnreadMessageCount({ boardId }))
      }
    } else if (actionName + elementName === 'LikeBoardChatMessage/Data/Like') {
      const { MessageId, UserId } = data

      if (UserId === currentUserId) {
        yield put(setMessageLiked({
          boardId,
          messageId: MessageId,
          isLiked: true
        }))
      }

      yield put(increaseMessageLikeCount({
        boardId,
        messageId: MessageId
      }))
    } else if (actionName + elementName === 'UnlikeBoardChatMessage/Data/Like') {
      const { MessageId, UserId } = data

      if (UserId === currentUserId) {
        yield put(setMessageLiked({
          boardId,
          messageId: MessageId,
          isLiked: false
        }))
      }

      yield put(decreaseMessageLikeCount({
        boardId,
        messageId: MessageId
      }))
    } else if (actionName + elementName === 'AddDocumentsSourceToBoard/Data/DocumentsSourceWithBoardId') {
      const DocumentSource = data

      yield put(addDocumentSource({
        boardId,
        documentSource: {
          id: DocumentSource.Id,
          name: DocumentSource.Name,
          url: DocumentSource.Url
        }
      }))
    } else if (actionName + elementName === 'SetDefaultDocumentsSource/Data/DocumentsSourceWithBoardId') {
      const DocumentSource = data

      yield put(setDefaultDocumentSource({
        boardId,
        documentSourceId: DocumentSource.Id
      }))
    } else if (actionName + elementName === 'RemoveDocumentsSourceFromBoard/Data/DocumentsSourceWithBoardId') {
      const { Id } = data

      yield put(removeDocumentSource({
        boardId,
        documentSourceId: Id
      }))
    } else if (actionName + elementName === 'RenameDocumentsSource/Data/DocumentsSourceName') {
      const DocumentSource = data
      yield put(setDocumentSource({
        documentSource: {
          id: DocumentSource.Id,
          name: DocumentSource.Name
        }
      }))
    } else if (actionName + elementName === 'AddDocumentTemplateSourceToBoard/Data/AddDocumentTemplateSourceToBoard') {
      yield put(addDocumentTemplateSource({
        boardId,
        documentTemplateSourceId: data.Id,
      }))
    } else if (actionName + elementName === 'RemoveDocumentTemplateSourceFromBoard/Data/RemoveDocumentTemplateSourceFromBoard') {
      yield put(removeDocumentTemplateSource({
        boardId,
        documentTemplateSourceId: data.Id,
      }))
    } else if (actionName + elementName === 'AddGroupToBoard/Data/GroupInBoard') {
      const Group = data

      yield put(addUserGroup({
        id: Group.GroupId,
        name: Group.Name,
        internal: Group.Internal,
        external: Group.External,
      }))

      yield put(addUserGroupToView({
        boardId,
        userGroup: {
          id: Group.GroupId,
          permissionLevel: Group.PermissionLevel,
        }
      }))

      yield put(refreshUsers({
        boardId
      }))
    } else if (actionName + elementName === 'ChangeGroupPermissionLevelInBoard/Data/GroupInBoard') {
      const Group = data

      yield put(addUserGroupToView({
        boardId,
        userGroup: {
          id: Group.GroupId,
          permissionLevel: Group.PermissionLevel,
        }
      }))
    } else if (actionName + elementName === 'RemoveGroupFromBoard/Data/GroupInBoard') {
      const Group = data

      yield put(removeUserGroupFromView({
        boardId,
        userGroupId: Group.GroupId
      }))

      yield put(refreshUsers({
        boardId
      }))
    } else if (actionName + elementName === 'AddCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(addDate({
        boardId,
        date: {
          id: CustomDate.Id,
          cardId: CustomDate.CardId,
          type: CalendarItemTypes.CUSTOM_DATE,
          name: CustomDate.Name,
          timestamp: CustomDate.Timestamp
        }
      }))
    } else if (actionName + elementName === 'RemoveCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(removeDate({
        boardId,
        dateId: CustomDate.Id
      }))
    } else if (actionName + elementName === 'RenameCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(setDate({
        boardId,
        date: {
          id: CustomDate.Id,
          name: CustomDate.Name
        }
      }))
    } else if (actionName + elementName === 'SetCustomDate/Data/CalendarEvent') {
      const CustomDate = data
      yield put(setDate({
        boardId,
        date: {
          id: CustomDate.Id,
          timestamp: CustomDate.Timestamp
        }
      }))
    } else if (actionName + elementName === 'AddCardSuccessor/Data/CardSequence') {
      const { PredCardId, SuccCardId } = data

      yield put([
        addCardRelation({
          id: PredCardId,
          successorIds: [SuccCardId]
        }),
        addCardRelation({
          id: SuccCardId,
          predecessorIds: [PredCardId]
        })
      ])
    } else if (actionName + elementName === 'AddCardParent/Data/CardParent') {
      const { CardId, ParentCardId } = data

      yield put([
        addCardRelation({
          id: ParentCardId,
          childIds: [CardId]
        }),
        addCardRelation({
          id: CardId,
          parentIds: [ParentCardId],
        })
      ])
    } else if (actionName + elementName === 'RemoveCardSuccessor/Data/CardSequence') {
      const { PredCardId, SuccCardId } = data

      yield put([
        removeCardRelation({
          id: PredCardId,
          successorIds: [SuccCardId]
        }),
        removeCardRelation({
          id: SuccCardId,
          predecessorIds: [PredCardId]
        })
      ])
    } else if (actionName + elementName === 'RemoveCardParent/Data/CardParent') {
      const { CardId, ParentCardId } = data

      yield put([
        removeCardRelation({
          id: ParentCardId,
          childIds: [CardId]
        }),
        removeCardRelation({
          id: CardId,
          parentIds: [ParentCardId],
        })
      ])
    } else if (actionName === 'change:card') {
      yield handleCardChange(data)
    } else if (actionName === 'change:cards') {
      const length = data.length
      for (let i = 0; i < length; i++) {
        yield handleCardChange(data[i])
      }
    } else if (actionName === 'SetBoardAsPrivate') {
      yield put(setIsPublic({ boardId, isPublic: false }))
      yield put(fetchPermissionLevel({ boardId }))
    } else if (actionName === 'SetBoardAsPublic') {
      yield put(setIsPublic({ boardId, isPublic: true }))
      yield put(fetchPermissionLevel({ boardId }))
    } else if (actionName + elementName === 'SetDefaultOwnersGroup/Data/OwnersGroupData') {
      yield put(setDefaultOwnerUserGroupId({ boardId, userGroupId: data.GroupId }))
    } else if (actionName + elementName === 'SetDefaultMembersGroup/Data/MembersGroupData') {
      yield put(setDefaultMemberUserGroupId({ boardId, userGroupId: data.GroupId }))
    } else if (actionName + elementName === 'SetDefaultVisitorsGroup/Data/VisitorsGroupData') {
      yield put(setDefaultVisitorUserGroupId({ boardId, userGroupId: data.GroupId }))
    } else if (actionName + elementName === 'AddBlockerToBoard/Data/Blocker') {
      const Blocker = data

      yield put([
        addBlocker({
          id: Blocker.Id,
          type: Blocker.Type,
          name: Blocker.Name,
          description: Blocker.Description && JSON.parse(Blocker.Description),
          position: Blocker.Position,
        }),
        addBlockerToBoard({
          boardId,
          blockerId: Blocker.Id,
        }),
      ])
    } else if (actionName + elementName === 'RemoveBlockerFromBoard/Primitive/Int32') {
      const { Value } = data

      yield put(removeBlockerFromBoard({
        boardId,
        blockerId: Value,
      }))
    } else if (actionName + elementName === 'SetCardStatusDescription/Data/CardStatus/Description') {
      const { Id, Description } = data

      yield put(setCardStatusDescription({
        boardId,
        cardStatusId: Id,
        description: Description,
      }))
    }
  } else if (channel === 'boardSettings-' + boardId) { // ----- BOARD SETTINGS CHANNEL -----
    if (actionName + elementName === 'ChangeBoardSettings/Data/Settings') {
      const { Settings } = data

      yield put(setSettings({
        boardId,
        settings: {
          allowCardRemove: Settings.AllowCardRemove,
          chat: Settings.Chat,
          joinMode: Settings.JoinMode,
          lang: Settings.Lang,
          timeline: Settings.Timeline,
          enableAnalytics: Settings.EnableAnalytics,
          cardTemplateId: Settings.CardTemplateId
        }
      }))
    } else if (actionName + elementName === 'AddCardStatus/Data/CardStatus') {
      const Status = data

      yield put(addCardStatus({
        boardId,
        cardStatus: {
          id: Status.Id,
          name: Status.Name,
          description: Status.Description,
          role: Status.Role,
          isDefault: Status.IsDefault,
          color: Status.Color,
          position: Status.Position
        }
      }))
    } else if (actionName + elementName === 'RemoveCardStatus/Primitive/Int32') {
      const { Value } = data
      yield put(removeStatusFromAllCards({
        status: Value
      }))
      yield put(removeCardStatus({
        boardId,
        cardStatusId: Value
      }))
    } else if (elementName === '/Positions/CardStatuses') {
      const { Positions } = data

      if (Positions.length) {
        yield put(setCardStatusPositions({
          boardId,
          positions: Positions.map(Position => ({
            id: Position.Id,
            position: Position.Position
          }))
        }))
      }
    } else if (actionName + elementName === 'RenameCardStatus/Data/Status/Name') {
      const { Id, Name } = data

      yield put(setCardStatusName({
        boardId,
        cardStatusId: Id,
        name: Name,
      }))
    } else if (actionName + elementName === 'ChangeCardStatusColor/Data/CardStatus') {
      const { Id, Color } = data

      yield put(setCardStatusColor({
        boardId,
        cardStatusId: Id,
        color: Color
      }))
    } else if (
      actionName + elementName === 'ChangeCardStatusRole/Partial/CardStatusesInBoard' ||
      actionName + elementName === 'SetDefaultCardStatus/Partial/CardStatusesInBoard'
    ) {
      const { Statuses } = data

      yield put(addCardStatusArray({
        boardId,
        array: Statuses.map(Status => ({
          id: Status.Id,
          name: Status.Name,
          description: Status.Description,
          role: Status.Role,
          isDefault: Status.IsDefault,
          color: Status.Color,
          position: Status.Position
        }))
      }))
    }
  } else if (channel === 'archive-' + boardId) { // ----- BOARD ARCHIVE CHANNEL -----
    if (actionName + elementName === 'RemoveCard/Data/Card') {
      const { Id } = data

      yield put(removeArchivedCard({
        boardId,
        id: Id
      }))
    }
  } else if (channel === 'activity-board-' + boardId) { // ----- BOARD ACTIVITY CHANNEL -----
    if (actionName + elementName === 'AddNotification/Data/Notification') {
      const activity = mapActivityData(data)

      if (activity.data.replacedNotificationId) {
        yield put(removeActivity({
          boardId,
          activityId: activity.data.replacedNotificationId
        }))
      }

      yield put(addActivity({
        boardId,
        activity,
      }))
    }
  } else if (channel === 'incoming-mail-' + boardId) { // ----- BOARD INCOMING MAIL CHANNEL -----
    if (actionName + elementName === 'AddIncomingMail/Data/IncomingMail') {
      const IncomingMail = data

      yield put(addIncomingMail({
        name: IncomingMail.Name,
        boardId: IncomingMail.BoardId,
        cardId: IncomingMail.CardId,
        cardTemplateId: IncomingMail.CardTemplateId,
        validateAddress: IncomingMail.ValidateAddress
      }))
    } else if (actionName + elementName === 'RemoveIncomingMail/Data/IncomingMail') {
      const IncomingMail = data

      yield put(removeIncomingMail({
        name: IncomingMail.Name
      }))
    } else if (actionName + elementName === 'ChangeIncomingMail/Data/IncomingMail') {
      const IncomingMail = data

      yield put(setIncomingMail({
        name: IncomingMail.Name,
        boardId: IncomingMail.BoardId,
        cardId: IncomingMail.CardId,
        cardTemplateId: IncomingMail.CardTemplateId,
        validateAddress: IncomingMail.ValidateAddress
      }))
    }
  } else if (channel === '@' + currentUserId) { // ----- PERSONAL CHANNEL -----
    if (actionName + elementName === 'BoardsPermissionChange/Data/Array<Int32>') {
      const boardIds = data

      if (boardIds.indexOf(boardId) !== -1) {
        yield put(fetchPermissionLevel({ boardId }))
      }
    } else if (
      actionName + elementName === 'AddUserToGroup/InternalGroupPermissionChange' ||
      actionName + elementName === 'RemoveUserFromGroup/InternalGroupPermissionChange'
    ) {
      if (data.BoardId && data.BoardId === boardId) {
        yield put(fetchPermissionLevel({ boardId }))
      }
    } else if (actionName + elementName === 'AddBookmark/Data/BookmarkData') {
      const { ActivityId } = data

      yield put(setActivity({
        boardId,
        activity: {
          id: ActivityId,
          isBookmarked: true
        }
      }))
    } else if (actionName + elementName === 'RemoveBookmark/Primitive/Int32') {
      const { Value } = data

      yield put(setActivity({
        boardId,
        activity: {
          id: Value,
          isBookmarked: false
        }
      }))
    }
  }
}
